require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-campaign-environment-climate-spanish.json") })
        }
      }, "path---es-mx-campaign-environment-climate-spanish");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-campaign-environment-climate-spanish!./.cache/json/es-mx-campaign-environment-climate-spanish.json
// module id = 885
// module chunks = 231608221292675